/**
 * @author: lv.chen
 * @date: 2026/3/5
 * @desc: GameSelectionNew组件
 */
import React, { useRef, useState } from 'react';
import { useDeepCompareEffect } from 'ahooks';
import GameSelection from '@intelligence/components/GameSelection';
import { fetchGameDetails } from '@intelligence/v3/utils/filterTagNameAnalyser';

import type { GameSelectionProps } from '@intelligence/components/GameSelection/types';

interface IGameSelectionNewProps extends IBaseProps, GameSelectionProps {}

const GameSelectionNew: React.FC<IGameSelectionNewProps> = (props) => {
  const { value, checkedList: checkedListProps, onConfirm: onConfirmProps, ...restProps } = props;

  const initialized = useRef(false);

  const [checkedList, setCheckedList] = useState<any[]>(checkedListProps);

  const updateCheckedList = async (gameIds: string[]) => {
    const gameDetails = await fetchGameDetails(gameIds);
    setCheckedList(gameDetails);
    initialized.current = true;
  };

  const handleConfirm = (...args: [string[], string, boolean, any[]]) => {
    setCheckedList(args?.[3] || []);
    onConfirmProps?.(...args);
  };

  useDeepCompareEffect(() => {
    if (!Array.isArray(value) || value.length === 0) {
      setCheckedList([]);
      initialized.current = false;
      return;
    }

    if (initialized.current) {
      return;
    }

    if (Array.isArray(checkedListProps) && checkedListProps.length > 0) {
      setCheckedList(checkedListProps);
      return;
    }

    updateCheckedList(value);
  }, [value, checkedListProps]);

  return <GameSelection {...restProps} checkedList={checkedList} onConfirm={handleConfirm} />;
};

export default GameSelectionNew;
